import axios from "axios";

const api = axios.create({
  baseURL: "https://henriqueritter-happy-deploy.herokuapp.com/",
});

export default api;
